const StatusVisitaFiliado = [
  {
    label: "Encerrada",
    visitaEncerrada: true
  },
  {
    label: "Em andamento",
    visitaEncerrada: false
  }
];

export {StatusVisitaFiliado};
